// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bl3q","delete":"styles_delete__1qczE","update":"styles_update__1xM24","add":"styles_add__SprUo"};